import { Tasks } from '../utils/types';

function formatChileanDate(dateString: string): string {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('es-CL', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZone: 'America/Santiago',
  }).format(date);
}

function getFormattedDate(task: Tasks): string {
  if (task.date) {
    return formatChileanDate(task.date);
  } else if (task.is_asap) {
    return 'Lo antes posible';
  } else if (task.is_flexible_date) {
    return 'Fecha flexible';
  } else {
    return 'Sin especificar';
  }
}

export function generateAcceptedTaskEmail({
  task,
  address,
}: {
  task: Tasks;
  address: string;
}) {
  const TITLE = '¡Tu Task ha sido aprobada!';
  const formattedDate = getFormattedDate(task);

  return `
    <table width="100%" cellspacing="0" cellpadding="0" style="background-color: #f3f4f6; font-family: Arial, 'Helvetica Neue', sans-serif;">
        <tr>
            <td align="center" style="padding: 20px 0;">
                <table width="100%" cellspacing="0" cellpadding="0" style="max-width: 600px; border-radius: 10px; overflow: hidden;background-color: white">
                    <tr>
                        <td>
                            <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/accepted-task-email-top-3.png" alt="Tasky Header" width="100%" style="display: block; max-width: 100%;">
                        </td>
                    </tr>
                    <tr>
                        <td bgcolor="#ffffff" style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;">
                            <table width="100%" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td style="padding: 40px 20px 20px;">
                                        <h1 style="text-align: center; color: #333333; margin-top: 0; margin-bottom: 40px;">${TITLE}</h1>

                                        <p style="color: #333333; font-size: 18px; margin-bottom: 30px;">Hola ${task.name},</p>
                                        <p style="color: #333333; font-size: 18px; margin-bottom: 30px;">Tu task fue aprobada y ahora estamos buscando el Tasker ideal para realizar la tarea.</p>

                                        <table width="100%" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td style="padding: 20px 0;">
                                                    <table width="100%" cellspacing="0" cellpadding="0">
                                                        <tr>
                                                            <td style="color: #666666; font-size: 20px; font-weight: bold;">Total</td>
                                                            <td style="color: #333333; font-size: 24px; font-weight: bold; text-align: right;">$${task.price}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>

                                        <!-- Gray Divider -->
                                        <table width="100%" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td style="border-top: 1px solid #cccccc; padding: 10px 0;"></td>
                                            </tr>
                                        </table>

                                        <table width="100%" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td style="padding: 20px 0;">
                                                    <p style="color: #666666; font-size: 18px; font-weight: bold; margin: 0;">Cuando</p>
                                                    <p style="color: #333333; font-size: 20px; font-weight: bold; margin: 5px 0 0 0;">${formattedDate}</p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table width="100%" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td style="padding: 20px 0;">
                                                    <p style="color: #666666; font-size: 18px; font-weight: bold; margin: 0;">Dónde</p>
                                                    <p style="color: #333333; font-size: 20px; font-weight: bold; margin: 5px 0 0 0;">${address}</p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table width="100%" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td style="padding: 20px 0;">
                                                    <p style="color: #666666; font-size: 18px; font-weight: bold; margin: 0;">Categoría</p>
                                                    <p style="color: #333333; font-size: 20px; font-weight: bold; margin: 5px 0 0 0;">${task.category}</p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table width="100%" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td style="padding: 20px 0;">
                                                    <p style="color: #666666; font-size: 18px; font-weight: bold; margin: 0;">Descripción</p>
                                                    <p style="color: #666666; font-size: 18px; margin: 5px 0 0 0;">${task.description}</p>
                                                </td>
                                            </tr>
                                        </table>
                                        <table width="100%" cellspacing="0" cellpadding="0" bgcolor="#8B5CF6" style="margin-top: 40px; padding: 20px; border-radius: 10px;">
                                            <tr>
                                                <td align="center">
                                                    <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/tasky-logo-dark-theme.png" alt="Tasky Logo" width="80" style="display: block; margin: 0 auto;">
                                                    <div style="margin-top: 20px;">
                                                        <a href="https://www.instagram.com/tasky.cl" style="margin: 0 10px; outline: none; text-decoration: none;">
                                                            <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/instagram-icon.png" alt="Instagram" width="24">
                                                        </a>
                                                        <a href="https://www.linkedin.com/company/taskyapp/" style="margin: 0 10px; outline: none; text-decoration: none;">
                                                            <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/linkedin-icon.png" alt="LinkedIn" width="24">
                                                        </a>
                                                        <a href="https://www.tiktok.com/@tasky.cl" style="margin: 0 10px; outline: none; text-decoration: none;">
                                                            <img src="https://lefgpghkpyydyoooswkw.supabase.co/storage/v1/object/public/dev/common/tiktok-icon.png" alt="TikTok" width="24">
                                                        </a>
                                                    </div>
                                                    <p style="color: #ffffff; font-size: 11px; margin-top: 10px;">Pide tu Task y universitarios resuelven</p>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
  `;
}
